import { FileUp, Cpu, FileOutput, Download } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { useI18n } from '@/lib/i18n'

interface Step {
  titleKey: 'flowSelectTitle' | 'flowProcessTitle' | 'flowGenerateTitle' | 'flowDownloadTitle'
  descKey: 'flowSelectDesc' | 'flowProcessDesc' | 'flowGenerateDesc' | 'flowDownloadDesc'
  icon: LucideIcon
}

const STEPS: readonly Step[] = [
  { titleKey: 'flowSelectTitle', descKey: 'flowSelectDesc', icon: FileUp },
  { titleKey: 'flowProcessTitle', descKey: 'flowProcessDesc', icon: Cpu },
  { titleKey: 'flowGenerateTitle', descKey: 'flowGenerateDesc', icon: FileOutput },
  { titleKey: 'flowDownloadTitle', descKey: 'flowDownloadDesc', icon: Download },
]

/** Four-step local processing pipeline. */
export function WorkflowSection() {
  const { t } = useI18n()

  return (
    <section className="border-t bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">{t('flowTitle')}</h2>
          <p className="mt-4 text-lg text-muted-foreground">{t('flowSubtitle')}</p>
        </div>

        <ol className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, index) => (
            <li key={step.titleKey} className="relative space-y-3">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg border bg-card text-primary">
                  <step.icon className="h-5 w-5" aria-hidden />
                </span>
                <span className="font-mono text-sm text-muted-foreground">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>
              <h3 className="text-lg font-semibold">{t(step.titleKey)}</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">{t(step.descKey)}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}